<template>
  <div class="login">
    <p class="register" @click="$router.push('/register')">注册</p>
    <h1 class="title">登录</h1>
    <LoginInput
      placeholderpaw="请输入验证码"
      :codeBtn="true"
      loginBtn="登录"
      :serviceFlag="false"
      @clickBtn="clickBtn"
    />
    <router-link to="/login" style="color:#666">用户名密码登录</router-link> 
  </div>
</template>

<script>
import LoginInput from "../../components/LoginInput";
export default {
  name: "phone-login",
  data() {
    return {};
  },
  components: {
    LoginInput
  },
  methods: {
    clickBtn(obj) {
      console.log(obj);
      // 1、判断滑块是否完成
      if (!obj.dragSuccess) {
        this.$toast("请拖动滑块完成验证");
        return;
      }
      let data = {
        phone: obj.phone,
        smsCode: obj.paw
      };
      this.$store
        .dispatch("PhoneLogin", data)
        .then(() => {
          this.$toast.success("登录成功");
          this.$router.push({ path: "/" });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.login {
  padding: 0 30px;
}
.register {
  text-align: right;
  padding-top: 55px;
  font-size: 30px;
  color: #666;
}
.title {
  font-size: 50px;
  margin: 95px 0 165px 0;
}
</style>